import { render, staticRenderFns } from "./DepartmentFilterGroups.vue?vue&type=template&id=26681995&scoped=true&"
import script from "./DepartmentFilterGroups.vue?vue&type=script&lang=js&"
export * from "./DepartmentFilterGroups.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentFilterGroups.vue?vue&type=style&index=0&id=26681995&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26681995",
  null
  
)

export default component.exports